import { render } from "./ContentCard.vue?vue&type=template&id=e2a66320&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"

import "./ContentCard.vue?vue&type=style&index=0&id=e2a66320&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a66320"]])

export default __exports__